console.log('✅ Event loaded currently-attached-listener-registry.js.');

// Internal registry of listeners
const registry = [];

/**
 * Register an event listener and record its teardown.
 * Guards against duplicate registrations.
 * @param {EventTarget} target - Element, Window, or Document
 * @param {string} event - Event type (e.g., 'click')
 * @param {Function} handler - Listener function
 * @param {Object|boolean} [options] - Options for addEventListener
 * @returns {Function} unsubscribe - Call to remove this listener
 */

export function addListenerViaCurrentlyAttachedListenersRegistry(target, event, handler, options) {
  // Check for duplicates
  const exists = registry.some(
    entry =>
      entry.target === target &&
      entry.event === event &&
      entry.handler === handler &&
      JSON.stringify(entry.options) === JSON.stringify(options)
  );
  if (exists) {
    // Already registered; return a no-op unsubscribe
    return () => {};
  }

  target.addEventListener(event, handler, options);

  // Build unsubscribe function
  const unsub = () => target.removeEventListener(event, handler, options);

  // Store in registry
  registry.push({ target, event, handler, options, unsub });

  return unsub;
}

/**
 * Remove all registered listeners at once.
 */
export function clearAllListenersFromCurrentlyAttachedListenersRegistry() {
  // Teardown every listener
  registry.forEach(entry => entry.unsub());
  // Clear the registry
  registry.length = 0;
  console.log('All registered listeners have been cleared.');
}

/**
 * Manually execute all registered event handlers directly.
 * Useful for testing and debugging handlers without simulating DOM events.
 */
export function executeListenerViaCurrentlyAttachedListeners() {
  console.log('🚀 Executing registered event listeners directly...');

  registry.forEach((entry, index) => {
    try {
      entry.handler();
      console.log(`✅ Listener ${index + 1} (${entry.event}) executed successfully.`);
    } catch (error) {
      console.error(`❌ Error executing listener ${index + 1} (${entry.event}):`, error);
    }
  });

  // Clear the registry after execution to avoid repeated calls
  registry.length = 0;
  console.log('✅ All registered listeners executed and registry cleared.');
}

/**
 * Executes all event listeners currently registered in the registry manually.
 * Typically useful for debugging or manually triggering events.
 */
//export function executeListenerViaCurrentlyAttachedListeners() {
//    console.log("🚀 Executing all registered event listeners manually...");

//    registry.forEach((entry, index) => {
//        try {
//            // Manually invoke the handler with a synthetic Event object
//            const syntheticEvent = new Event(entry.event, { bubbles: true, cancelable: true });
//            entry.handler.call(entry.target, syntheticEvent);
//            console.log(`✅ Executed listener #${index + 1} [${entry.event}] successfully.`);
//        } catch (error) {
//            console.error(`❌ Error executing listener #${index + 1} [${entry.event}]:`, error);
//        }
//    });

//    console.log("✅ Completed manual execution of all registered listeners.");
//}

//export function executeListenerViaCurrentlyAttachedListeners() {
//    console.log("🚀 Executing registered event listeners...");
//    registry.forEach((entry, index) => {
//        try {
//            entry.handler();
//            console.log(`✅ Event listener ${index + 1} executed.`);
//        } catch (error) {
//            console.error(`❌ Error executing listener ${index + 1}:`, error);
//        }
//    });
//    // Clear the registry to prevent duplicate calls
//    registry.length = 0;

//}
